"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_flash_1 = require("./awsui-flash");
var FlashbarWrapper = /** @class */ (function (_super) {
    __extends(FlashbarWrapper, _super);
    function FlashbarWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlashbarWrapper.prototype.findItems = function () {
        return this.findAll('.awsui-flashbar awsui-flash').map(function (item) { return new awsui_flash_1.default(item.getElement()); });
    };
    return FlashbarWrapper;
}(dom_1.ComponentWrapper));
exports.default = FlashbarWrapper;
//# sourceMappingURL=awsui-flashbar.js.map